import { Button, Image, Label, Link, makeStyles, Persona, Subtitle1, tokens } from "@fluentui/react-components";
import { ArrowRepeatAllFilled } from "@fluentui/react-icons";
import { useCallback, useState } from "react";
import ChangeProductDialog from "./dialogs/ChangeProductDialog";

const useStyles = makeStyles({
    root: {
        backgroundColor: tokens.colorBrandBackground,
        color: tokens.colorNeutralForegroundStaticInverted + " !important",
        display: "flex",
        gap: "1rem",
        justifyContent: "space-between"
    },
    flexSection: {
        display: "flex",
        gap: "5px",
        alignItems: "center",

        "& *": {
            color: tokens.colorNeutralForegroundStaticInverted + " !important"
        }
    },
    headerMainLink: {
        backgroundColor: "transparent",
        height: "50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: tokens.colorNeutralForegroundStaticInverted,
        textDecoration: "none",
        padding: "0 1rem",
        minWidth: "50px",
        fontSize: "1.5rem",

        "&:hover": {
            color: tokens.colorNeutralForegroundStaticInverted,
            textDecoration: "none",
            backgroundColor: "#00000022"
        },
        "&:active": {
            color: tokens.colorNeutralForegroundStaticInverted,
            textDecoration: "none",
            backgroundColor: "#00000033"
        },

        "&.active": {
            backgroundColor: "#fff !important",
            color: tokens.colorNeutralForeground1 + " !important"
        }
    },
    activeProductArea: {
        display: "flex",
        flexDirection: "column",
        alignItems: "end",
        justifyContent: "center",
        padding: "0 1rem"
    }
});

export default function HeaderBar() {
    const styles = useStyles();
    const [ changeProductOpen, setChangeProductOpen ] = useState<boolean>(false);

    const changeProduct = useCallback(
        () => {
            setChangeProductOpen( true );
        },
        []
    );

    // @ts-ignore
    const userName = globalThis[ "session" ].user.name;

    return (
        <div className={styles.root}>
            <div className={styles.flexSection}>
                <Link href="/" className={styles.headerMainLink}>
                    <Image src="/images/mc.png" style={{ height: "100%", padding: "10px" }} />
                    <Subtitle1>Mission Control</Subtitle1>
                </Link>
            </div>
            <div className={styles.flexSection}>
                <div className={styles.activeProductArea}>
                    <Label>[ACTIVE_PRODUCT_NAME]</Label>
                    <Button appearance="outline" size="small" icon={<ArrowRepeatAllFilled />} onClick={changeProduct}>
                        Change Product
                    </Button>
                </div>
                <Link href="#" className={styles.headerMainLink}>
                    <Persona textAlignment="center" textPosition="before" size="medium" name={userName} secondaryText={"Domain Administrator"} />
                </Link>
            </div>

            <ChangeProductDialog open={changeProductOpen} setOpen={setChangeProductOpen} />
        </div>
    );
}